export default "__VITE_ASSET__fyABHPs5__"